const HOUSE_REWIRE_OPTIONS = {
  NOT_NEEDED: {display: 'Not Needed', value: 'Not Needed', showOrder: 0, def: true},
  TOTAL: {display: 'Total', value: 'Total', showOrder: 1, def: false},
  PARTIAL: {display: 'Partial', value: 'Partial', showOrder: 2, def: false},
};
export {HOUSE_REWIRE_OPTIONS};